export const bodyXs =
  "font-sans font-medium text-xs leading-4 tracking-normal no-underline";

export const bodyXsBold =
  "font-sans font-bold text-xs leading-4 tracking-normal no-underline";

export const bodySm =
  "font-sans font-medium text-sm leading-5 tracking-normal no-underline";

export const bodySmBold =
  "font-sans font-bold text-sm leading-5 tracking-normal no-underline";

export const bodySmSemibold =
  "font-sans font-semibold text-sm leading-5 tracking-normal no-underline";

export const bodySmUnderline =
  "font-sans font-medium text-sm leading-5 tracking-normal underline";

export const bodyMd =
  "font-sans font-normal text-base leading-6 tracking-normal no-underline";

export const bodyMdSemibold =
  "font-sans font-semibold text-base leading-6 tracking-normal no-underline";

export const bodyMdBold =
  "font-sans font-bold text-base leading-6 tracking-normal no-underline";

export const bodyLg =
  "font-sans font-medium text-lg leading-7 tracking-normal no-underline";

export const bodyLgUnderline =
  "font-sans font-medium text-lg leading-7 tracking-normal underline";

export const bodyLgBold =
  "font-sans font-bold text-lg leading-7 tracking-normal no-underline";

export const bodyXsBoldNarrow =
  "font-sans font-bold text-xs leading-3 tracking-normal no-underline";

export const headingXs =
  "font-sans font-extrabold text-xs leading-4 tracking-normal no-underline";

export const headingSm =
  "font-sans font-extrabold text-sm leading-5 tracking-normal no-underline";

export const headingMd =
  "font-sans font-extrabold text-base leading-6 tracking-normal no-underline";

export const headingLg =
  "font-sans font-extrabold text-lg leading-7 tracking-normal no-underline";

export const headingXl =
  "font-sans font-extrabold text-xl leading-7 tracking-normal no-underline";

export const heading2xl =
  "font-sans font-extrabold text-2xl leading-8 tracking-normal no-underline";

export const heading3xl =
  "font-sans font-extrabold text-3xl leading-9 tracking-normal no-underline";

export const heading4xl =
  "font-sans font-extrabold text-4xl leading-10 tracking-normal no-underline";

export const heading5xl =
  "font-sans font-extrabold text-5xl leading-11 tracking-normal no-underline";
